// Merchant notes store links as [text](url) in the plain-text disclaimer column, so every
// surface (admin, web, mobile) renders the same note without a schema or API change.
const NOTE_LINK = /\[([^\]\n]+)\]\((https?:\/\/[^\s)]+)\)/g;

const splitNoteIntoSegments = note => {
  if (typeof note !== 'string' || !note) return [];
  const segments = [];
  let cursor = 0;
  for (const match of note.matchAll(NOTE_LINK)) {
    if (match.index > cursor) segments.push({ text: note.slice(cursor, match.index) });
    segments.push({ text: match[1], url: match[2] });
    cursor = match.index + match[0].length;
  }
  if (cursor < note.length) segments.push({ text: note.slice(cursor) });
  return segments;
};

const noteHasLinks = note => splitNoteIntoSegments(note).some(segment => segment.url);

// For surfaces that render the note as plain text: the link text stays, the url goes.
const noteToPlainText = note =>
  splitNoteIntoSegments(note)
    .map(segment => segment.text)
    .join('');

module.exports = { splitNoteIntoSegments, noteHasLinks, noteToPlainText };
